import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';

export interface MonthlyRevenue {
	month: string;
	revenue: number;
}

export interface TopPlatform {
	name: string;
	orders: number;
	percentage: number;
}

export interface PaymentMethodStat {
	/** Method code, translated under dashboard.paymentMethods.methods.* */
	method: 'STRIPE' | 'REVOLUT' | 'BIZUM' | 'CRYPTO' | 'DIRECT';
	orders: number;
	completed: number;
	notCompleted: number;
	revenue: number;
	avgTicket: number;
	percentage: number;
}

export interface RevenueBreakdownDTO {
	totalRevenue: number;
	ownerRevenue: number;
	clientsRevenue: number;
	partnerCommission: number;
	samuRevenue: number;
}

export interface DashboardKpisDTO {
	totalRevenue: number;
	totalOrders: number;
	totalUsers: number;
	avgTicket: number;
	monthlyRevenue: MonthlyRevenue[];
	topPlatforms: TopPlatform[];
	paymentMethods: PaymentMethodStat[];
}

@Injectable({ providedIn: 'root' })
export class DashboardApiService {
	private readonly http = inject(HttpClient);
	private readonly baseUrl = `${environment.pathBackend}/dashboard`;

	getKpis(period: string): Observable<DashboardKpisDTO> {
		const params = new HttpParams().set('period', period);
		return this.http.get<DashboardKpisDTO>(`${this.baseUrl}/kpis`, { params });
	}

	getRevenueBreakdown(period: string): Observable<RevenueBreakdownDTO> {
		const params = new HttpParams().set('period', period);
		return this.http.get<RevenueBreakdownDTO>(`${this.baseUrl}/revenue-breakdown`, { params });
	}
}
